import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { openRoutes } from "routes.js";
import "./styles.css";

const OpenLayout = () => {
    const location = useLocation();

    React.useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        // mainContent.current.scrollTop = 0;
    }, [location]);

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/card") {
                return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
            } else {
                return <Redirect to={"/card/nickyjacob"} key={key} />;
            }
        });
    };

    return (
        <>
            <div>
                <Switch>
                    {getRoutes(openRoutes)}
                    <Redirect from="*" to="/card/nickyjacob" />
                </Switch>
            </div>
        </>
    );
};

export default OpenLayout;
